(function(){
    'use strict';
    angular.module('Filters').filter('removeDuplicatedDrivers', function() {
        return function(array) {
            const uniqueArray = [];
            array.forEach(item => {
                const found = uniqueArray.filter(driver => {
                   return driver.id === item.id;
                });

                if(found.length === 0) {
                    uniqueArray.push(item);
                }
            });
            return uniqueArray;
        }
    });
})();


// WEBPACK FOOTER //
// ./js/filters/removeDuplicatedDrivers.js